export default class ReadMore {
    /**
     * @param {HTMLElement} element The readmore button
     */
    constructor(element) {
        this.element = element;
        this.active = false;
        //initialising read more button.
        if(element) {
            let readMoreWrapper = element.parentElement;
            if(readMoreWrapper !== null) {
                //ensuring all required content is set.
                if(typeof readMoreWrapper.dataset.excerpt === "undefined") {
                    throw new Error("[readmore.js] The readmore button wrapper requires a excerpt dataset")
                }
                
                if(typeof readMoreWrapper.dataset.fullText === "undefined") {
                    throw new Error("[readmore.js] The readmore button wrapper requires a full text dataset")
                }

                this.fullText = readMoreWrapper.dataset.fullText;
                this.excerpt = readMoreWrapper.dataset.excerpt

                element.addEventListener('click', e => {
                    e.preventDefault();
                    this.modifyText();
                })
            } else {
                throw new Error("[readmore.js] the readmore button has no parent ", element);
            }
        }
    }

    modifyText() {
        let readMoreWrapper = this.element.parentElement;
        
        //if we have already created the content.
        let readMoreContent = readMoreWrapper.querySelector('.readmore-text');
        
        if(readMoreContent === null) {
            throw new Error("[readmore.js] please include a readmore span");
        }

        if(readMoreContent !== null) {
            readMoreContent.innerHTML = (this.active === false) ? readMoreWrapper.dataset.fullText : readMoreWrapper.dataset.excerpt;
            this.element.innerHTML = (this.active === false) ? 'Show Less' : 'Read More'
            if(this.active === false) {
                this.element.classList.add('active');
            } else {
                this.element.classList.remove('active');
            }
            this.active = !this.active;
        }
    }
}